import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "animate.css";
import './assets/style/iconfont.scss'
import ElementUI from "element-ui";
import 'element-ui/lib/theme-chalk/index.css';
import "./assets/style/element-variables.scss";

Vue.config.productionTip = false;
Vue.directive("scroll-reveal", {
  inserted(el, binding, vnode) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            el.classList.add("animate-block");
            observer.unobserve(el);
          }
        });
      },
      {
        threshold: 0.1,
      }
    );

    observer.observe(el);
  },
});
Vue.use(ElementUI);

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
